import React from "react"
import { connect } from "react-redux"
import { registerAction } from "actions/registerAction"
import { orgRegisterAction } from "actions/registerAction"
import classnames from "classnames"
import { Tabs } from "@feuer/react-tabs"
import { Redirect } from "react-router-dom"

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap"

import AuthHeader from "components/Headers/AuthHeader.js"

class Register extends React.Component {
  state = {
    name: "",
    email: "",
    password: "",
    privacyPolicy: null,
    customerFormError: null,
    merchantFormError: null,
  }
  onChange = (stateName, value) => {
    this.setState({
      [stateName]: value,
    })
  }
  render() {
    const { registerError, authError2 } = this.props
    const styles = {
      textAlign: "center",
    }
    const { auth, profile } = this.props
    if (auth.uid) {
      if (!auth.emailVerified) {
        console.log("Debug-0")
        return <Redirect to="/emailVerify" />
      } else if (profile.isLoaded && profile.token.claims.role_merchant) {
        return <Redirect to="/m/dashboard" />
      } else if (profile.isLoaded && profile.token.claims.role_admin) {
        return <Redirect to="/d/dashboard" />
      } else {
        return <Redirect to="/l" />
      }
    }
    let checkboxClass = ""
    if (this.state.privacyPolicy === true) checkboxClass = "is-valid"
    else if (this.state.privacyPolicy === false) checkboxClass = "is-invalid"
    return (
      <>
        <AuthHeader />
        <Container className="mt--8 pb-4">
          <Row className="justify-content-center">
            <Col lg="6" md="8">
              <Card className="bg-secondary border-0">
                <div style={styles}>
                  <Tabs
                    activeTab={{
                      id: "individual",
                    }}
                  >
                    <Tabs.Tab id="individual" title="Individual">
                      {/*<CardHeader className="bg-transparent pb-5">
                    <div className="text-muted text-center mt-2 mb-4">
                      <small>Sign up with</small>
                    </div>
                    <div className="text-center">
                      <Button
                        className="btn-neutral btn-icon mr-4"
                        color="default"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <span className="btn-inner--icon mr-1">
                          <img
                            alt="..."
                            src={require("assets/img/icons/common/facebook.svg")}
                          />
                        </span>
                        <span className="btn-inner--text">Facebook</span>
                      </Button>
                      <Button
                        className="btn-neutral btn-icon"
                        color="default"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        <span className="btn-inner--icon mr-1">
                          <img
                            alt="..."
                            src={require("assets/img/icons/common/google.svg")}
                          />
                        </span>
                        <span className="btn-inner--text">Google</span>
                      </Button>
                    </div>
                  </CardHeader>*/}
                      <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center text-muted mb-4">
                          <small>Sign up with your credentials</small>
                        </div>
                        <Form role="form">
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedName,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-hat-3" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.name}
                                placeholder="Name"
                                type="text"
                                onFocus={() =>
                                  this.setState({ focusedName: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedName: false })
                                }
                                onChange={(e) =>
                                  this.onChange("name", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedEmail,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-email-83" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.email}
                                placeholder="Email"
                                type="email"
                                onFocus={() =>
                                  this.setState({ focusedEmail: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedEmail: false })
                                }
                                onChange={(e) =>
                                  this.onChange("email", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedPassword,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-lock-circle-open" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.password}
                                placeholder="Password"
                                type="password"
                                onFocus={() =>
                                  this.setState({ focusedPassword: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedPassword: false })
                                }
                                onChange={(e) =>
                                  this.onChange("password", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <Row className="my-4">
                            <Col xs="12">
                              <FormGroup>
                                <div className="custom-control custom-control-alternative custom-checkbox">
                                  <input
                                    className={
                                      "custom-control-input " + checkboxClass
                                    }
                                    id="customCheckRegister-customer"
                                    type="checkbox"
                                    checked={this.state.privacyPolicy || false}
                                    onChange={(e) => {
                                      // console.log(e.target.checked);
                                      this.setState({
                                        privacyPolicy: e.target.checked,
                                      })
                                    }}
                                    required
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customCheckRegister-customer"
                                  >
                                    <span className="text-muted">
                                      I agree with the{" "}
                                      <a
                                        href="#pablo"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        Privacy Policy
                                      </a>
                                    </span>
                                  </label>
                                  <div className="valid-feedback">
                                    Looks Good!
                                  </div>
                                  <div className="invalid-feedback">
                                    You must agree before submitting.
                                  </div>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="text-center">
                            <Button
                              className="mt-2 mb-2"
                              color="default"
                              type="button"
                              onClick={(e) => {
                                e.preventDefault()
                                const { privacyPolicy, name } = this.state
                                if (privacyPolicy && name) {
                                  return this.props.registerAction(
                                    this.state.name,
                                    this.state.email,
                                    this.state.password
                                  )
                                }
                                if (name.length < 3) {
                                  this.setState({
                                    customerFormError:
                                      "Name Must Be At Least 3 Characters!",
                                  })
                                } else {
                                  this.setState({ customerFormError: null })
                                }
                                if (this.state.privacyPolicy === null) {
                                  this.setState({ privacyPolicy: false })
                                }
                              }}
                            >
                              Create Account
                            </Button>
                            <br />
                            <span className="text-danger">
                              {registerError ? <p>{registerError}</p> : null}
                            </span>
                            <br />
                            <span className="text-danger">
                              {this.state.customerFormError ? (
                                <p>{this.state.customerFormError}</p>
                              ) : null}
                            </span>
                          </div>
                        </Form>
                      </CardBody>
                    </Tabs.Tab>
                    <Tabs.Tab id="merchant" title="Merchant">
                      <CardBody className="px-lg-5 py-lg-5">
                        <div className="text-center text-muted mb-4">
                          <small>Sign up with your merchant email</small>
                        </div>
                        <Form role="form">
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedName,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-hat-3" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.name}
                                placeholder="Merchant Name"
                                type="text"
                                onFocus={() =>
                                  this.setState({ focusedName: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedName: false })
                                }
                                onChange={(e) =>
                                  this.onChange("name", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedEmail,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-email-83" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.email}
                                placeholder="Merchant Email"
                                type="email"
                                onFocus={() =>
                                  this.setState({ focusedEmail: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedEmail: false })
                                }
                                onChange={(e) =>
                                  this.onChange("email", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <FormGroup
                            className={classnames({
                              focused: this.state.focusedPassword,
                            })}
                          >
                            <InputGroup className="input-group-merge input-group-alternative">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="ni ni-lock-circle-open" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                value={this.state.password}
                                placeholder="Password"
                                type="password"
                                onFocus={() =>
                                  this.setState({ focusedPassword: true })
                                }
                                onBlur={() =>
                                  this.setState({ focusedPassword: false })
                                }
                                onChange={(e) =>
                                  this.onChange("password", e.target.value)
                                }
                                autoComplete="off"
                              />
                            </InputGroup>
                          </FormGroup>
                          <Row className="my-4">
                            <Col xs="12">
                              <div className="custom-control custom-control-alternative custom-checkbox">
                                <input
                                  className={
                                    "custom-control-input " + checkboxClass
                                  }
                                  id="customCheckRegister-merchant"
                                  type="checkbox"
                                  checked={this.state.privacyPolicy || false}
                                  onChange={(e) => {
                                    // console.log(e.target.checked);
                                    this.setState({
                                      privacyPolicy: e.target.checked,
                                    })
                                  }}
                                  required
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customCheckRegister-merchant"
                                >
                                  <span className="text-muted">
                                    I agree with the{" "}
                                    <a
                                      href="#pablo"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Privacy Policy
                                    </a>
                                  </span>
                                </label>
                                <div className="valid-feedback">
                                  Looks Good!
                                </div>
                                <div className="invalid-feedback">
                                  You must agree before submitting.
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <div className="text-center">
                            <Button
                              className="mt-2 mb-2"
                              color="default"
                              type="button"
                              onClick={(e) => {
                                e.preventDefault()
                                const { privacyPolicy, name } = this.state
                                if (privacyPolicy && name) {
                                  return this.props.orgRegisterAction(
                                    this.state.name,
                                    this.state.email,
                                    this.state.password
                                  )
                                }
                                if (name.length < 3) {
                                  this.setState({
                                    merchantFormError:
                                      "Name Must Be At Least 3 Characters!",
                                  })
                                } else {
                                  this.setState({ merchantFormError: null })
                                }
                                if (this.state.privacyPolicy === null) {
                                  this.setState({ privacyPolicy: false })
                                }
                              }}
                            >
                              Create Account
                            </Button>
                            <br />
                            <span className="text-danger">
                              {authError2 ? <p>{authError2}</p> : null}
                            </span>
                            <br />
                            <span className="text-danger">
                              {this.state.merchantFormError ? (
                                <p>{this.state.merchantFormError}</p>
                              ) : null}
                            </span>
                          </div>
                        </Form>
                      </CardBody>
                    </Tabs.Tab>
                  </Tabs>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    registerError: state.authState.registerError,
    authError2: state.authState.authError2,
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}

const mapDispatchToProps = (dispatch) => ({
  registerAction: (name, email, password) =>
    dispatch(registerAction(name, email, password)),
  orgRegisterAction: (name, email, password) =>
    dispatch(orgRegisterAction(name, email, password)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Register)
